import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    Button,
    Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import Checkbox from '@mui/material/Checkbox';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import 'react-toastify/dist/ReactToastify.css';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const SendNotifications = ({ openDialog, setOpenDialog, edit, setEdit, selectedBanner, setGetbanners }) => {
    const [formData, setFormData] = useState({
        title: "",
        message: "",
    });
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [users, setUsers] = useState([]);
    const [loading, setloading] = useState(false);
    console.log(selectedUsers.length)

    const ALL_OPTION = { _id: "all", name: "Select All" };
    const options = [ALL_OPTION, ...users.filter(user => user.status === true)];


    const handleChange = (event, newValue) => {
        if (newValue.some((item) => item._id === "all")) {
            if (selectedUsers.length === users.length) {
                setSelectedUsers([]);
            } else {
                setSelectedUsers(users.map((u) => u._id));
            }
        } else {
            setSelectedUsers(newValue.map((u) => u._id));
        }
    };

    const handleUsers = async () => {
        try {
            const response = await instance.get(`/Customer/getAllCustomers`);
            // console.log("response", response.data.data);
            setUsers(response.data.data);
        } catch (error) {
            console.log("error", error);
        }
    }
    useEffect(() => {
        handleUsers();
    }, []);

    const handleClose = () => {
        setOpenDialog(loading === false ? false : true);
        setEdit(false);
        setSelectedUsers([]);
        setFormData({
            title: "",
            message: "",
        })
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: files ? files[0] : value, // Handle file input separately
        }));
    };

    //addbanner
    const handleAddBanner = async () => {
        const { title, message } = formData;
        if (!title || !message || !selectedUsers.length) {
            toast.error("All fields are required!");
            return;
        }
        try {
            setloading(true);
            const response = await instance.post('/Notifications/sendBulkNotifications', {
                users_ids: selectedUsers,
                title: formData.title,
                message: formData.message
            });

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setGetbanners(true)
            } else {
                toast.error(response.data.message)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
        } finally {
            setloading(false);
        }
    }


    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    Push Notifications
                    <Typography>Send Push Notifications to users</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-admin">
                        <Grid container spacing={3}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                {/* <div className='admin-textfiled'> */}
                                <Autocomplete
                                    multiple
                                    options={options}
                                    limitTags={1}
                                    value={options.filter(opt => selectedUsers.includes(opt._id) && opt._id !== "all")}
                                    onChange={handleChange}
                                    getOptionLabel={(option) => option.name || option.email || "Unnamed User"}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                            <Checkbox checked={selected} style={{ marginRight: 8 }} />
                                            {option.name || option.email || "Unnamed User"}
                                        </li>
                                    )}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select Users" placeholder="Users" required />
                                    )}
                                />

                                {/* </div> */}
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter title"
                                        label="title"
                                        type="text"
                                        fullWidth
                                        required
                                        name="title"
                                        // size="small"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                <div className="admin-textfiled">
                                    <TextField
                                        placeholder="Enter Message"
                                        label="Message"
                                        type="text"
                                        fullWidth
                                        required
                                        name="message"
                                        // size="small"
                                        value={formData.message}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                </DialogContent>
                <DialogActions>
                    <Button className="cancel-btn" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button className="add-btn" disabled={loading} onClick={handleAddBanner}>
                        {loading ? (
                            <>
                                <span className="spinner"></span> Loading...
                            </>
                        ) : (
                            "Send"
                        )}
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment >
    );
};

export default SendNotifications;
